"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f97 = void 0;
exports.f97 = {
    "aa": [
        "Latn",
        "Arab",
        "Ethi"
    ],
    "aaa": [
        "Latn"
    ],
    "aab": [
        "Latn"
    ],
    "aac": [
        "Latn"
    ],
    "aad": [
        "Latn"
    ],
    "aae": [
        "Latn",
        "Grek"
    ],
    "aaf": [
        "Zyyy"
    ],
    "aag": [
        "Latn"
    ],
    "aah": [
        "Latn"
    ],
    "aai": [
        "Latn"
    ],
    "aak": [
        "Latn"
    ],
    "aal": [
        "Latn"
    ],
    "aan": [
        "Latn"
    ],
    "aao": [
        "Arab"
    ],
    "aap": [
        "Latn"
    ],
    "aaq": [
        "Latn"
    ],
    "aas": [
        "Latn"
    ],
    "aat": [
        "Grek"
    ],
    "aau": [
        "Latn"
    ],
    "aaw": [
        "Latn"
    ],
    "aax": [
        "Latn"
    ],
    "aaz": [
        "Latn"
    ],
    "ab": [
        "Cyrl",
        "Geor"
    ],
    "aba": [
        "Latn"
    ],
    "abb": [
        "Latn"
    ],
    "abc": [
        "Latn"
    ],
    "abd": [
        "Latn"
    ],
    "abe": [
        "Latn"
    ],
    "abf": [
        "Latn"
    ],
    "abg": [
        "Latn"
    ],
    "abh": [
        "Arab"
    ],
    "abi": [
        "Latn"
    ],
    "abj": [
        "Zyyy"
    ],
    "abl": [
        "Rjng"
    ],
    "abm": [
        "Latn"
    ],
    "abn": [
        "Latn"
    ],
    "abo": [
        "Latn"
    ],
    "abp": [
        "Latn"
    ],
    "abq": [
        "Cyrl",
        "Latn"
    ],
    "abr": [
        "Latn"
    ],
    "abs": [
        "Latn"
    ],
    "abt": [
        "Latn"
    ],
    "abu": [
        "Latn"
    ],
    "abv": [
        "Arab"
    ],
    "abw": [
        "Latn"
    ],
    "abx": [
        "Latn"
    ],
    "aby": [
        "Latn"
    ],
    "abz": [
        "Latn"
    ],
    "aca": [
        "Latn"
    ],
    "acb": [
        "Latn"
    ],
    "acd": [
        "Latn"
    ],
    "ace": [
        "Latn",
        "Arab"
    ],
    "acf": [
        "Latn"
    ],
    "ach": [
        "Latn"
    ],
    "aci": [
        "Zyyy"
    ],
    "ack": [
        "Zyyy"
    ],
    "acl": [
        "Zyyy"
    ],
    "acm": [
        "Arab"
    ],
    "acn": [
        "Latn"
    ],
    "acp": [
        "Latn"
    ],
    "acq": [
        "Arab"
    ],
    "acr": [
        "Latn"
    ],
    "acs": [
        "Latn"
    ],
    "act": [
        "Latn"
    ],
    "acu": [
        "Latn"
    ],
    "acv": [
        "Latn"
    ],
    "acw": [
        "Arab"
    ],
    "acx": [
        "Arab"
    ],
    "acy": [
        "Latn",
        "Arab",
        "Grek"
    ],
    "acz": [
        "Latn"
    ],
    "ada": [
        "Latn"
    ],
    "adb": [
        "Latn"
    ],
    "add": [
        "Latn"
    ],
    "ade": [
        "Latn"
    ],
    "adf": [
        "Arab"
    ],
    "adg": [
        "Latn"
    ],
    "adh": [
        "Latn"
    ],
    "adi": [
        "Latn",
        "Tibt"
    ],
    "adj": [
        "Latn"
    ],
    "adl": [
        "Latn"
    ],
    "adn": [
        "Latn"
    ],
    "ado": [
        "Latn"
    ],
    "adq": [
        "Latn"
    ],
    "adr": [
        "Latn"
    ],
    "ads": [
        "Latn",
        "Zxxx"
    ],
    "adt": [
        "Latn"
    ],
    "adu": [
        "Latn"
    ],
    "adw": [
        "Latn"
    ],
    "adx": [
        "Tibt"
    ],
    "ady": [
        "Cyrl",
        "Arab",
        "Latn"
    ],
    "adz": [
        "Latn"
    ],
    "ae": [
        "Avst",
        "Arab",
        "Gujr"
    ],
    "aea": [
        "Latn"
    ],
    "aeb": [
        "Arab",
        "Latn"
    ],
    "aec": [
        "Arab"
    ],
    "aed": [
        "Zxxx"
    ],
    "aee": [
        "Arab"
    ],
    "aek": [
        "Latn"
    ],
    "ael": [
        "Latn"
    ],
    "aem": [
        "Latn"
    ],
    "aen": [
        "Zxxx"
    ],
    "aeq": [
        "Arab"
    ],
    "aer": [
        "Latn"
    ],
    "aes": [
        "Zyyy"
    ],
    "aeu": [
        "Latn"
    ],
    "aew": [
        "Latn"
    ],
    "aey": [
        "Latn"
    ],
    "aez": [
        "Latn"
    ],
    "af": [
        "Latn",
        "Arab",
        "Brai"
    ],
    "afb": [
        "Arab"
    ],
    "afd": [
        "Latn"
    ],
    "afe": [
        "Latn"
    ],
    "afg": [
        "Zxxx"
    ],
    "afh": [
        "Latn"
    ],
    "afi": [
        "Latn"
    ],
    "afk": [
        "Latn"
    ],
    "afn": [
        "Latn"
    ],
    "afo": [
        "Latn"
    ],
    "afp": [
        "Latn"
    ],
    "afs": [
        "Latn"
    ],
    "aft": [
        "Zyyy"
    ],
    "afu": [
        "Latn"
    ],
    "afz": [
        "Latn"
    ],
    "aga": [
        "Latn"
    ],
    "agb": [
        "Latn"
    ],
    "agc": [
        "Latn"
    ],
    "agd": [
        "Latn"
    ],
    "age": [
        "Latn"
    ],
    "agf": [
        "Latn"
    ],
    "agg": [
        "Latn"
    ],
    "agh": [
        "Latn"
    ],
    "agi": [
        "Deva"
    ],
    "agj": [
        "Ethi",
        "Arab"
    ],
    "agk": [
        "Latn"
    ],
    "agl": [
        "Latn"
    ],
    "agm": [
        "Latn"
    ],
    "agn": [
        "Latn"
    ],
    "ago": [
        "Latn"
    ],
    "agq": [
        "Latn"
    ],
    "agr": [
        "Latn"
    ],
    "ags": [
        "Latn"
    ],
    "agt": [
        "Latn"
    ],
    "agu": [
        "Latn"
    ],
    "agv": [
        "Latn"
    ],
    "agw": [
        "Latn"
    ],
    "agx": [
        "Cyrl"
    ],
    "agy": [
        "Latn"
    ],
    "agz": [
        "Latn"
    ],
    "aha": [
        "Latn"
    ],
    "ahb": [
        "Latn"
    ],
    "ahg": [
        "Ethi"
    ],
    "ahh": [
        "Latn"
    ],
    "ahi": [
        "Latn"
    ],
    "ahk": [
        "Latn",
        "Mymr",
        "Thai"
    ],
    "ahl": [
        "Latn"
    ],
    "ahm": [
        "Latn"
    ],
    "ahn": [
        "Latn"
    ],
    "aho": [
        "Ahom"
    ],
    "ahp": [
        "Latn"
    ],
    "ahr": [
        "Zyyy"
    ],
    "ahs": [
        "Latn"
    ],
    "aht": [
        "Latn"
    ],
    "aia": [
        "Latn"
    ],
    "aib": [
        "Arab"
    ],
    "aic": [
        "Latn"
    ],
    "aid": [
        "Latn"
    ],
    "aie": [
        "Latn"
    ],
    "aif": [
        "Latn"
    ],
    "aig": [
        "Latn"
    ],
    "aih": [
        "Zyyy"
    ],
    "aii": [
        "Cyrl",
        "Syrc"
    ],
    "aij": [
        "Hebr"
    ],
    "aik": [
        "Latn"
    ],
    "ail": [
        "Latn"
    ],
    "aim": [
        "Latn"
    ],
    "ain": [
        "Kana",
        "Latn"
    ],
    "aio": [
        "Mymr"
    ],
    "aip": [
        "Latn"
    ],
    "aiq": [
        "Arab"
    ],
    "air": [
        "Latn"
    ],
    "ait": [
        "Latn"
    ],
    "aiw": [
        "Arab",
        "Ethi",
        "Latn"
    ],
    "aix": [
        "Latn"
    ],
    "aiy": [
        "Latn"
    ],
    "aja": [
        "Latn"
    ],
    "ajg": [
        "Latn"
    ],
    "aji": [
        "Latn"
    ],
    "ajn": [
        "Latn"
    ],
    "ajp": [
        "Arab"
    ],
    "ajt": [
        "Arab",
        "Hebr"
    ],
    "aju": [
        "Arab"
    ],
    "ajw": [
        "Latn"
    ],
    "ajz": [
        "Latn"
    ],
    "ak": [
        "Latn",
        "Arab"
    ],
    "akb": [
        "Latn",
        "Batk"
    ],
    "akc": [
        "Latn"
    ],
    "akd": [
        "Latn"
    ],
    "ake": [
        "Latn"
    ],
    "akf": [
        "Latn"
    ],
    "akg": [
        "Latn"
    ],
    "akh": [
        "Latn"
    ],
    "aki": [
        "Latn"
    ],
    "akj": [
        "Zyyy"
    ],
    "akk": [
        "Xsux"
    ],
    "akl": [
        "Latn"
    ],
    "akm": [
        "Zyyy"
    ],
    "ako": [
        "Latn"
    ],
    "akp": [
        "Latn"
    ],
    "akq": [
        "Latn"
    ],
    "akr": [
        "Latn"
    ],
    "aks": [
        "Latn"
    ],
    "akt": [
        "Latn"
    ],
    "aku": [
        "Latn"
    ],
    "akv": [
        "Cyrl"
    ],
    "akw": [
        "Latn"
    ],
    "akx": [
        "Zyyy"
    ],
    "aky": [
        "Zyyy"
    ],
    "akz": [
        "Latn"
    ],
    "ala": [
        "Latn"
    ],
    "alc": [
        "Latn"
    ],
    "ald": [
        "Latn"
    ],
    "ale": [
        "Latn",
        "Cyrs"
    ],
    "alf": [
        "Latn"
    ],
    "alh": [
        "Latn"
    ],
    "ali": [
        "Latn"
    ],
    "alj": [
        "Latn"
    ],
    "alk": [
        "Zyyy"
    ],
    "all": [
        "Mlym"
    ],
    "alm": [
        "Latn"
    ],
    "aln": [
        "Latn",
        "Brai"
    ],
    "alo": [
        "Latn"
    ],
    "alp": [
        "Latn"
    ],
    "alq": [
        "Latn"
    ],
    "alr": [
        "Cyrl"
    ],
    "alt": [
        "Cyrl",
        "Mong"
    ],
    "alu": [
        "Latn"
    ],
    "alw": [
        "Ethi"
    ],
    "alx": [
        "Latn"
    ],
    "aly": [
        "Latn"
    ],
    "alz": [
        "Latn"
    ],
    "am": [
        "Ethi",
        "Arab",
        "Brai"
    ],
    "ama": [
        "Latn"
    ],
    "amb": [
        "Latn"
    ],
    "amc": [
        "Latn"
    ],
    "ame": [
        "Latn"
    ],
    "amf": [
        "Ethi",
        "Latn"
    ],
    "amg": [
        "Latn"
    ],
    "ami": [
        "Latn",
        "Zyyy"
    ],
    "amj": [
        "Latn"
    ],
    "amk": [
        "Latn"
    ],
    "aml": [
        "Zyyy"
    ],
    "amm": [
        "Latn"
    ],
    "amn": [
        "Latn"
    ],
    "amo": [
        "Latn"
    ],
    "amp": [
        "Latn"
    ],
    "amq": [
        "Latn"
    ],
    "amr": [
        "Latn"
    ],
    "ams": [
        "Zyyy"
    ],
    "amt": [
        "Latn"
    ],
    "amu": [
        "Latn"
    ],
    "amv": [
        "Latn"
    ],
    "amw": [
        "Arab",
        "Armi",
        "Latn",
        "Syrj"
    ],
    "amx": [
        "Latn"
    ],
    "amy": [
        "Latn"
    ],
    "amz": [
        "Latn"
    ],
    "an": [
        "Latn"
    ],
    "ana": [
        "Latn"
    ],
    "anb": [
        "Latn"
    ],
    "anc": [
        "Latn"
    ],
    "and": [
        "Latn"
    ],
    "ane": [
        "Latn"
    ],
    "anf": [
        "Latn"
    ],
    "ang": [
        "Latn"
    ],
    "anh": [
        "Latn"
    ],
    "ani": [
        "Cyrl"
    ],
    "anj": [
        "Latn"
    ],
    "ank": [
        "Latn"
    ],
    "anl": [
        "Latn"
    ],
    "anm": [
        "Latn"
    ],
    "ann": [
        "Latn"
    ],
    "ano": [
        "Latn"
    ],
    "anp": [
        "Deva"
    ],
    "anq": [
        "Deva",
        "Latn"
    ],
    "anr": [
        "Deva"
    ],
    "ans": [
        "Latn"
    ],
    "ant": [
        "Latn"
    ],
    "anu": [
        "Ethi",
        "Arab",
        "Latn"
    ],
    "anv": [
        "Latn"
    ],
    "anw": [
        "Latn"
    ],
    "anx": [
        "Latn"
    ],
    "any": [
        "Latn"
    ],
    "anz": [
        "Latn"
    ],
    "aoa": [
        "Latn"
    ],
    "aob": [
        "Latn"
    ],
    "aoc": [
        "Latn"
    ],
    "aod": [
        "Latn"
    ],
    "aoe": [
        "Latn"
    ],
    "aof": [
        "Latn"
    ],
    "aog": [
        "Latn"
    ],
    "aoh": [
        "Latn"
    ],
    "aoi": [
        "Latn"
    ],
    "aoj": [
        "Latn"
    ],
    "aok": [
        "Latn"
    ],
    "aol": [
        "Latn"
    ],
    "aom": [
        "Latn"
    ],
    "aon": [
        "Latn"
    ],
    "aor": [
        "Latn"
    ],
    "aos": [
        "Latn"
    ],
    "aot": [
        "Beng",
        "Latn"
    ],
    "aou": [
        "Zyyy"
    ],
    "aox": [
        "Latn"
    ],
    "aoz": [
        "Latn"
    ],
    "apb": [
        "Latn"
    ],
    "apc": [
        "Arab"
    ],
    "apd": [
        "Arab",
        "Latn"
    ],
    "ape": [
        "Latn"
    ],
    "apf": [
        "Latn"
    ],
    "apg": [
        "Latn"
    ],
    "aph": [
        "Deva"
    ],
    "api": [
        "Latn"
    ],
    "apj": [
        "Latn"
    ],
    "apk": [
        "Latn"
    ],
    "apl": [
        "Latn"
    ],
    "apm": [
        "Latn"
    ],
    "apn": [
        "Latn"
    ],
    "apo": [
        "Latn"
    ],
    "app": [
        "Latn"
    ],
    "apq": [
        "Zyyy"
    ],
    "apr": [
        "Latn"
    ],
    "aps": [
        "Latn"
    ],
    "apt": [
        "Latn"
    ],
    "apu": [
        "Latn"
    ],
    "apv": [
        "Latn"
    ],
    "apw": [
        "Latn"
    ],
    "apx": [
        "Latn"
    ],
    "apy": [
        "Latn"
    ],
    "apz": [
        "Latn"
    ],
    "aqc": [
        "Cyrl"
    ],
    "aqd": [
        "Latn"
    ],
    "aqg": [
        "Latn"
    ],
    "aqk": [
        "Latn"
    ],
    "aqm": [
        "Latn"
    ],
    "aqn": [
        "Latn"
    ],
    "aqp": [
        "Zyyy"
    ],
    "aqr": [
        "Latn"
    ],
    "aqt": [
        "Latn"
    ],
    "aqz": [
        "Latn"
    ],
    "ar": [
        "Arab",
        "Brai",
        "Syrc"
    ],
    "arc": [
        "Armi",
        "Nbat",
        "Palm",
        "Syrc"
    ],
    "ard": [
        "Latn"
    ],
    "are": [
        "Latn"
    ],
    "arh": [
        "Latn"
    ],
    "ari": [
        "Latn"
    ],
    "arj": [
        "Latn"
    ],
    "ark": [
        "Latn"
    ],
    "arl": [
        "Latn"
    ],
    "arn": [
        "Latn"
    ],
    "aro": [
        "Latn"
    ],
    "arp": [
        "Latn"
    ],
    "arq": [
        "Arab"
    ],
    "arr": [
        "Latn"
    ],
    "ars": [
        "Arab"
    ],
    "aru": [
        "Latn"
    ],
    "arv": [
        "Zyyy"
    ],
    "arw": [
        "Latn"
    ],
    "arx": [
        "Latn"
    ],
    "ary": [
        "Arab"
    ],
    "arz": [
        "Arab",
        "Brai"
    ],
    "as": [
        "Beng"
    ],
    "asa": [
        "Latn"
    ],
    "asb": [
        "Latn"
    ],
    "asc": [
        "Latn"
    ],
    "ase": [
        "Sgnw",
        "Zxxx"
    ],
    "asf": [
        "Zxxx"
    ],
    "asg": [
        "Latn"
    ],
    "ash": [
        "Latn"
    ],
    "asi": [
        "Latn"
    ],
    "asj": [
        "Latn"
    ],
    "ask": [
        "Arab"
    ],
    "asl": [
        "Latn"
    ],
    "asn": [
        "Latn"
    ],
    "aso": [
        "Latn"
    ],
    "asp": [
        "Zxxx"
    ],
    "asq": [
        "Zxxx"
    ],
    "asr": [
        "Deva"
    ],
    "ass": [
        "Latn"
    ],
    "ast": [
        "Latn"
    ],
    "asu": [
        "Latn"
    ],
    "asv": [
        "Latn"
    ],
    "asw": [
        "Zxxx"
    ],
    "asx": [
        "Latn"
    ],
    "asy": [
        "Latn"
    ],
    "asz": [
        "Latn"
    ],
    "ata": [
        "Latn"
    ],
    "atb": [
        "Latn",
        "Lisu"
    ],
    "atc": [
        "Latn"
    ],
    "atd": [
        "Latn"
    ],
    "ate": [
        "Latn"
    ],
    "atg": [
        "Latn"
    ],
    "ati": [
        "Latn"
    ],
    "atj": [
        "Latn"
    ],
    "atk": [
        "Latn"
    ],
    "atl": [
        "Latn"
    ],
    "atm": [
        "Latn"
    ],
    "atn": [
        "Arab"
    ],
    "ato": [
        "Latn"
    ],
    "atp": [
        "Latn"
    ],
    "atq": [
        "Latn"
    ],
    "atr": [
        "Latn"
    ],
    "ats": [
        "Latn"
    ],
    "att": [
        "Latn"
    ],
    "atu": [
        "Latn"
    ],
    "atv": [
        "Cyrl"
    ],
    "atw": [
        "Latn"
    ],
    "atx": [
        "Latn"
    ],
    "aty": [
        "Latn"
    ],
    "atz": [
        "Latn"
    ],
    "aua": [
        "Latn"
    ],
    "aub": [
        "Zyyy"
    ],
    "auc": [
        "Latn"
    ],
    "aud": [
        "Latn"
    ],
    "aug": [
        "Latn"
    ],
    "auh": [
        "Latn"
    ],
    "aui": [
        "Latn"
    ],
    "auj": [
        "Zyyy"
    ],
    "auk": [
        "Latn"
    ],
    "aul": [
        "Latn"
    ],
    "aum": [
        "Latn"
    ],
    "aun": [
        "Latn"
    ],
    "auo": [
        "Latn"
    ],
    "aup": [
        "Latn"
    ],
    "auq": [
        "Latn"
    ],
    "aur": [
        "Latn"
    ],
    "aut": [
        "Latn"
    ],
    "auu": [
        "Latn"
    ],
    "auw": [
        "Latn"
    ],
    "aux": [
        "Latn"
    ],
    "auy": [
        "Latn"
    ],
    "auz": [
        "Arab"
    ],
    "av": [
        "Cyrl"
    ],
    "avb": [
        "Latn"
    ],
    "avd": [
        "Zyyy"
    ],
    "avi": [
        "Latn"
    ],
    "avk": [
        "Latn"
    ],
    "avl": [
        "Arab"
    ],
    "avm": [
        "Latn"
    ],
    "avn": [
        "Latn"
    ],
    "avo": [
        "Latn"
    ],
    "avs": [
        "Latn"
    ],
    "avt": [
        "Latn"
    ],
    "avu": [
        "Latn"
    ],
    "avv": [
        "Latn"
    ],
    "awa": [
        "Deva"
    ],
    "awb": [
        "Latn"
    ],
    "awc": [
        "Latn"
    ],
    "awe": [
        "Latn"
    ],
    "awg": [
        "Latn"
    ],
    "awh": [
        "Latn"
    ],
    "awi": [
        "Latn"
    ],
    "awk": [
        "Latn"
    ],
    "awm": [
        "Latn"
    ],
    "awn": [
        "Ethi"
    ],
    "awo": [
        "Latn"
    ],
    "awr": [
        "Latn"
    ],
    "aws": [
        "Latn"
    ],
    "awt": [
        "Latn"
    ],
    "awu": [
        "Latn"
    ],
    "awv": [
        "Latn"
    ],
    "aww": [
        "Latn"
    ],
    "awx": [
        "Latn"
    ],
    "awy": [
        "Latn"
    ],
    "axb": [
        "Latn"
    ],
    "axe": [
        "Latn"
    ],
    "axg": [
        "Latn"
    ],
    "axk": [
        "Latn"
    ],
    "axl": [
        "Latn"
    ],
    "axm": [
        "Zyyy"
    ],
    "axx": [
        "Latn"
    ],
    "ay": [
        "Latn"
    ],
    "aya": [
        "Latn"
    ],
    "ayb": [
        "Latn"
    ],
    "ayc": [
        "Latn"
    ],
    "ayd": [
        "Latn"
    ],
    "aye": [
        "Latn"
    ],
    "ayg": [
        "Latn"
    ],
    "ayh": [
        "Arab"
    ],
    "ayi": [
        "Latn"
    ],
    "ayk": [
        "Latn"
    ],
    "ayl": [
        "Arab"
    ],
    "ayn": [
        "Arab"
    ],
    "ayo": [
        "Latn"
    ],
    "ayp": [
        "Arab"
    ],
    "ayq": [
        "Latn"
    ],
    "ays": [
        "Latn"
    ],
    "ayt": [
        "Latn"
    ],
    "ayu": [
        "Latn"
    ],
    "ayy": [
        "Latn"
    ],
    "ayz": [
        "Latn"
    ],
    "az": [
        "Latn",
        "Brai",
        "Cyrl",
        "Arab"
    ],
    "aza": [
        "Zyyy"
    ],
    "azb": [
        "Arab",
        "Cyrl",
        "Latn"
    ],
    "azd": [
        "Latn"
    ],
    "azg": [
        "Latn"
    ],
    "azm": [
        "Latn"
    ],
    "azn": [
        "Latn"
    ],
    "azo": [
        "Latn"
    ],
    "azt": [
        "Latn"
    ],
    "azz": [
        "Latn"
    ]
};
